<template>
  <div id="tour_dates_input" class="tour-dates-input-wrapper">
    <div v-if="show_selector" class="dropdown-closer" @click="toggle_selector"></div>
    <input :value="humanized_string"
           :class="css_classes"
           placeholder="Выберите дату тура"
           @click="toggle_selector"
           readonly
    >
    <discount-badge :discount="discount"
                    :discount_type="discount_type"                    
                    tooltip
    ></discount-badge>
    <tour-dates-selector v-if="show_selector"
                       :tour_dates="tour_dates"
                       :loading="dates_loading"
                       @select_date="on_change_date"
    />

  </div>
</template>
<script>

import TourDatesSelector from "./TourDatesSelector";
import moment from 'moment';
import DiscountBadge from "../shared/DiscountBadge";

// TourDatesInput Component
export default {
  components: {DiscountBadge, TourDatesSelector  },
  props:['tour'],
  data() {
    return {
      selected_date: {},
      tour_dates: [],
      show_selector: false,
      dates_loading: true
    }
  },
  computed: {
    css_classes(){
      let css = 'form-control tour-dates-input';
      if (this.show_selector) {
        css += ' active'
      }
      return css;
    },
    humanized_string() {
      let str = '';
      if (this.selected_date.attributes) {
        str = moment(this.selected_date.attributes.date).format('LL');
      }
      return str;
    },
    discount() {
      if (this.selected_date.attributes !== undefined) {return this.selected_date.attributes.discount}
      return 0;
    },
    discount_type() {
      if (this.selected_date.attributes !== undefined) {return this.selected_date.attributes.discount_type}
      return 'no_discount';
    },
  },
  beforeMount() {
    this.get_tour_dates()
  },
  methods: {
    get_tour_dates(){
      let vc = this,
          url = '/tour_dates',
          data = {
            tour_id: this.tour.id,
            actual: true
          };
      $.ajax({
        url: url,
        data: data,
        dataType: 'json',
        type: 'GET'
      }).done(function(data){
        // console.log(data);
        vc.$set(vc, 'tour_dates', data.data);
        if (vc.tour_dates.length > 0) {
          vc.$set(vc, 'selected_date', vc.tour_dates[0]);
          vc.$emit('change', vc.tour_dates[0]);
          // vc.on_change_date(vc.tour_dates[0]);
        }
        vc.$set(vc, 'dates_loading', false);
      }).fail(function(jqXHR, textStatus){
        const errors = jqXHR.responseJSON;
        // console.log(errors, textStatus);
        alert('Не удалось загрузить даты тура.', url);
      })
    },

    on_change_date(obj){
      // console.log('TourDatesInput handle object', obj);
      this.$set(this, 'selected_date', obj);
      this.$emit('change', obj);
      this.toggle_selector();
    },

    toggle_selector(){
      this.$set(this, 'show_selector', !this.show_selector);
    },
  }
}
</script>

